<template>
  <div class="auth-wrapper">
    <div class="auth-content">
      <div class="card shadow-lg border-0">
        <div class="card-body p-4 p-md-5">
          
          <!-- اللوجو في المنتصف -->
          <div class="auth-logo text-center mb-4">
            <img :src="'img/com.jpg'" alt="Logo" class="rounded-circle shadow-sm">
          </div>

          <!-- العناوين -->
          <div class="text-center mb-4">
            <h4 class="fw-bold text-dark mb-1">نظام تارجت للمقاولات</h4>
            <p class="text-muted small">سجل الدخول للمتابعة إلى لوحة التحكم</p>
          </div>

          <!-- نموذج الدخول -->
          <form @submit.prevent="login" dir="rtl" class="text-start">
            
            <!-- اسم المستخدم -->
            <div class="mb-3">
              <label class="form-label fw-bold small">اسم المستخدم</label>
              <div class="input-group-modern">
                <i class="bx bx-user"></i>
                <input v-model="form.email" type="text" class="form-control" placeholder="أدخل اسم المستخدم" required>
              </div>
              <span class="text-danger x-small d-block mt-1" v-if="errors.email">{{ errors.email[0] }}</span>
            </div>

            <!-- كلمة المرور -->
            <div class="mb-4">
              <label class="form-label fw-bold small">كلمة المرور</label>
              <div class="input-group-modern">
                <i class="bx bx-lock-alt"></i>
                <input v-model="form.password" type="password" class="form-control" placeholder="••••••••" required>
              </div>
              <span class="text-danger x-small d-block mt-1" v-if="errors.password">{{ errors.password[0] }}</span>
            </div>

            <!-- زر الدخول -->
            <button class="btn btn-primary w-100 py-3 rounded-3 shadow fw-bold" type="submit" :disabled="loadingPage">
              <span v-if="!loadingPage">تسجيل الدخول</span>
              <span v-else><i class="bx bx-loader-alt bx-spin me-2"></i> جاري التحقق...</span>
            </button>

          </form>

          <!-- فوتر بسيط -->
          <div class="mt-5 text-center border-top pt-3">
            <p class="text-muted x-small mb-0">نظام الإدارة المتكامل </p>
            <!-- <p class="text-muted x-small">&copy; 2024 جميع الحقوق محفوظة</p> -->
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/apis/User';
import Api from '@/apis/Api';
import jsCookie from 'js-cookie';

export default {
  data() {
    return {
      loadingPage: false,
      form: { email: "", password: "", device_name: "browser" },
      errors: []
    }
  },
  mounted() {
    sessionStorage.clear();
    localStorage.clear();
    jsCookie.remove('laravel_session');
  },
  methods: {
    login() {
      this.loadingPage = true;
      User.login(this.form).then(response => {
        this.$root.$emit("login", true);
        localStorage.setItem("token", "true");
        localStorage.setItem("auth", "true");
        User.auth().then(response => {
          localStorage.setItem("user", JSON.stringify(response.data));
          this.$store.dispatch("SetData", response.data);
          Api.get('/site').then(res => {
            this.$store.dispatch("SetDataSite", res.data);
            this.$router.push({ name: "Home" });
          });
        });
      }).catch(error => {
        this.loadingPage = false;
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
        }
      });
    }
  }
}
</script>

<style scoped>
/* التمركز المطلق في وسط الشاشة تماماً */
.auth-wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center; /* تمركز عمودي */
  justify-content: center; /* تمركز أفقي */
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  padding: 15px;
}

.auth-content {
  width: 100%;
  max-width: 450px; /* تحديد عرض الكارت ليظل متمركزاً */
}

.card {
  border-radius: 20px;
  overflow: hidden;
}

.auth-logo img {
  width: 90px;
  height: 90px;
  border: 4px solid #f8f9fa;
}

/* تنسيق المدخلات الحديثة */
.input-group-modern {
  position: relative;
  display: flex;
  align-items: center;
}

.input-group-modern i {
  position: absolute;
  right: 15px; /* وضع الأيقونة جهة اليمين للغة العربية */
  color: #0d6efd;
  font-size: 1.2rem;
  z-index: 5;
}

.input-group-modern .form-control {
  padding: 12px 45px 12px 15px; /* مساحة للأيقونة من اليمين */
  border-radius: 10px;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  width: 100%;
  text-align: right;
  transition: all 0.3s ease;
}

.input-group-modern .form-control:focus {
  background-color: #fff;
  border-color: #0d6efd;
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1);
  outline: none;
}

.btn-primary {
  background-color: #0d6efd;
  border: none;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #0b5ed7;
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);
}

.x-small {
  font-size: 0.75rem;
}
</style>